Wee.fn.make('outlet', {
	init: function() {
		Wee.easySlide.init({
			elementRef: 'salesSlide',
			trackerRef: 'salesSlide',
			arrows: 'arrow'
		});

		this.bind();
	},

	bind: function() {
		$.events.on({
			'ref:openSpecs': {
				click: function(e, el) {
					$('ref:specs').disable();

					$(el).parent()
						.find('ref:specs').enable();

					e.stopPropagation();
				}
			},
			'ref:closeSpecs': {
				click: function(e, el) {
					$(el).parent()
						.find('ref:specs').disable();

					e.stopPropagation();
					e.preventDefault();
				},
				mouseup: function(e) {
					e.stopPropagation();
				}
			}
		});
	}
});